angular.module("breadcrumb", [])

    .controller("BreadcrumbCtrl", function () {
        
    })


;